<template>
  <v-container fluid v-if="order!=null">
    <vue-headful :title="`Order Detail - Halalize for Business`" />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/orders/live?ref=detail' }">ออเดอร์วันนี้</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/view/shop/'+order.shop.ref_no }">{{order.shop.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <v-layout row wrap class="mt-4">
      <v-flex xs12 sm12 md8>
        <div class="grid-content bg-purple">
          <el-card class="box-card">
            <template v-if="order.status!='cancelled'">
              <ul
                class="progressbar"
                v-if="order.order_type=='delivery' || order.order_type=='pickup'"
              >
                <li :class="{'active':steps[0]==1}">สั่งซื้อ</li>
                <li :class="{'active':steps[1]==1}">ชำระเงิน</li>
                <li :class="{'active':steps[2]==1}">ยืนยันออเดอร์</li>
                <li :class="{'active':steps[3]==1}">ส่งให้ครัว</li>
                <li
                  :class="{'active':steps[4]==1, 'active-warning':['cooking', 'ready-to-go', 'delivering'].includes(order.status)}"
                >
                  <span v-if="order.status=='cooking'">กำลังทำอาหาร</span>
                  <span v-else-if="order.status=='ready-to-go'">พร้อมจัดส่ง</span>
                  <span
                    v-else-if="order.status=='delivering' || order.status=='completed'"
                  >กำลังจัดส่ง</span>
                  <span v-else>กำลังดำเนินการ</span>
                </li>
                <li :class="{'active':steps[5]==1}">จัดส่งแล้ว</li>
              </ul>

              <div style="clear:both;" class="pb-3"></div>
            </template>

            <!--
            <div
              v-if="order.status=='pending'"
              class="pa-1 text-xs-center white--text grey"
            >รอชำระเงิน</div>
            <div v-else-if="order.status=='new'" class="pa-1 text-xs-center white--text red">มาใหม่</div>
            <div
              v-else-if="order.status=='processing'"
              class="pa-1 text-xs-center white--text blue darken-2"
            >ส่งให้ร้านแล้ว</div>
            <div
              v-else-if="order.status=='cooking'"
              class="pa-1 text-xs-center white--text blue darken-4"
            >กำลังทำอาหาร</div>
            <div
              v-else-if="order.status=='completed'"
              class="pa-1 text-xs-center white--text green"
            >เรียบร้อยแล้ว</div>
            -->
            <div
              v-else-if="order.status=='cancelled'"
              class="pa-1 text-xs-center white--text grey"
            >ยกเลิกแล้ว</div>
            <div v-else class="pa-1 text-xs-center white--text orange">{{order.status}}</div>
            <section class="pa-3">
              <v-layout>
                <v-flex xs0 md4></v-flex>
                <v-flex xs12 md8 class="text-xs-right">
                  <!--
                  <el-row :gutter="0" class="title mb-3">
                    <el-col :span="12">
                      <strong>Order Status :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <el-tag type="warning" size="large">{{order.status}}</el-tag>
                    </el-col>
                  </el-row>
                  -->
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>หมายเลขออเดอร์ :</strong>
                    </el-col>
                    <el-col
                      :span="12"
                      class="text-xs-right"
                    >{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>สร้างเมื่อ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">{{order.created_at}}</el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ประเภทการสั่งซื้อ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.order_type=='pickup'">
                        <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                      </div>
                      <div v-if="order.order_type=='delivery'">
                        <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                      </div>
                      <div v-if="order.order_type=='ecommerce'">
                        <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                      </div>
                      <div v-if="order.order_type=='coupon'">
                        <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>การชำระเงิน :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.payment_type=='transfer'">โอนเงิน</div>
                      <div v-if="order.payment_type=='cash'">ชำระเงินสด</div>
                      <div v-if="order.payment_type=='creditcard'">บัตรเครดิต</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ช่องทางการขาย :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.order_channel=='liff'">Line Official Account</div>
                      <div v-else>{{order.order_channel}}</div>
                    </el-col>
                  </el-row>
                </v-flex>
              </v-layout>
            </section>
            <v-divider></v-divider>

            <v-layout row wrap>
              <v-flex xs12 md6 style="line-height:28px;">
                <section class="pa-3" v-if="order.order_type=='delivery'">
                  <h2 class="subtitle mb-3">ข้อมูลการจัดส่ง</h2>
                  <div class="mt-0">
                    <strong class="my-label">เส้นทาง :</strong>
                    <v-layout class="mt-3">
                      <v-flex xs12 sm12 md10>
                        <ul class="my-progress large" v-if="order.order_type=='delivery'">
                          <li class="progress__item progress__item--completed">
                            <p class="progress__title">{{order.shop.name}}</p>
                            <p class="progress__info">{{order.shop.formatted_address}}</p>
                          </li>
                          <li class="progress__item progress__item--active">
                            <p class="progress__title">
                              <a :href="gg_url" target="_blank">
                                <span
                                  v-if="order.delivery_info_json.whereTo.address.text"
                                >{{order.delivery_info_json.whereTo.address.text}}</span>
                                <span v-else>{{order.delivery_info_json.whereTo.address}}</span>
                              </a>
                            </p>
                          </li>
                        </ul>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div class="mt-0">
                    <strong class="my-label">ระยะทาง :</strong>
                    {{order.distance/1000 | numFormat('0.00')}} km
                  </div>
                  <div class="mt-1">
                    <strong class="my-label">เวลาจัดส่ง :</strong>
                    {{order.datetime_received | moment("DD/MM/YY HH:mm")}}
                    <el-tag
                      v-if="order.cluster_id!=null"
                      size="mini"
                      type="info"
                      class="ml-1"
                    >รอบส่ง {{order.shop.cluster_json.find(x=>x.id==order.cluster_id).delivery}}</el-tag>
                  </div>
                </section>
                <section class="pa-3" v-if="order.order_type=='pickup'">
                  <h2 class="subtitle mb-3">รับอาหารที่ร้าน</h2>
                  <div class="mt-4">
                    <strong class="my-label">สถานที่รับอาหาร :</strong>
                    {{order.shop.name}}
                    <p>{{order.shop.formatted_address}}</p>
                  </div>
                  <div class="mt-4">
                    <strong class="my-label">เวลารับอาหาร :</strong>
                    {{order.datetime_received | moment("DD/MM/YY HH:mm")}}
                  </div>
                </section>
              </v-flex>
              <v-divider vertical></v-divider>
              <v-flex xs12 md5>
                <section class="pa-3">
                  <h2 class="subtitle mb-3">ข้อมูลลูกค้า</h2>
                  <v-layout>
                    <v-flex xs12>
                      <div style="line-height:28px;">
                        <strong class="my-label">ชื่อ :</strong>
                        {{recipient.name}}
                        <br />
                        <span>
                          <strong class="my-label">เบอร์โทร :</strong>
                          {{recipient.mobile}}
                        </span>
                        <br />
                        <span>
                          <strong class="my-label">อีเมล :</strong>
                          ไม่ระบุ
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </section>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>
            <section class="pa-0 py-3">
              <h2 class="subtitle mb-3">คำสั่งซื้อ (#{{order.order_id | numFormat('0000000')}})</h2>
              <template v-if="order.order_basket.product_list.length>0">
                <el-row
                  :gutter="10"
                  v-for="(item, index) in order.order_basket.product_list"
                  v-bind:key="index"
                  class="pt-3"
                  style="border-bottom:1px solid #eee; min-height:90px;"
                >
                  <el-col :span="2" class="mb-3">
                    <span>{{item.quantity}} x</span>
                  </el-col>
                  <el-col :span="17" class="mb-3">
                    {{item.name}}
                    <div v-if="item.modifiers!=null">
                      <div
                        class="modifiers"
                        style="padding-left: 20px;"
                        v-for="(subject, index) in item.modifiers"
                        v-bind:key="index"
                      >
                        {{subject.title}}
                        <div v-if="!subject.duplicate">
                          <div v-for="(item, j) in subject.items" v-bind:key="j">
                            <li class="choice-item" v-if="item.checked">
                              {{item.name}}
                              <span v-if="item.price>0">({{item.price}} ฿)</span>
                            </li>
                          </div>
                        </div>
                        <div v-if="subject.duplicate">
                          <li
                            v-for="(item, j) in subject.items"
                            v-bind:key="j"
                          >{{item.name}} {{item.checked}}</li>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2" v-if="item.remark !=null">
                      <span
                        style="clear: left; border-radius:6px; "
                        class="py-2 px-4 grey lighten-3"
                      >
                        <i class="far fa-comment-dots"></i>
                        {{item.remark }}
                      </span>
                    </div>
                  </el-col>
                  <el-col
                    :span="5"
                    class="mb-3 text-xs-right"
                  >฿ {{item.line_subtotal | numFormat('0,0')}}</el-col>
                </el-row>

                <el-row :gutter="10" class="subtitle mt-3">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">ค่าอาหาร</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.food | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="subtitle">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">VAT</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.vat | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="subtitle">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{parseFloat(order.amount.delivery)+parseFloat(order.amount.delivery_tax) | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="subtitle" v-if="order.amount.extra>0">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">บริการเสริม (เก็บเงินปลายทาง)</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.extra | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row
                  :gutter="10"
                  class="subtitle green--text promotion mb-3 py-2"
                  v-if="order.amount.discount<0"
                >
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="14" class="mb-3">
                    ส่วนลด
                    <div class="green--text font-weight-bold" v-if="order.promotion_json!=null">
                      <v-icon small class="green--text">fa fa-tag</v-icon>
                      {{order.promotion_json[0].promotion_title}}
                    </div>
                  </el-col>
                  <el-col
                    :span="8"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.discount | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="title">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.total | numFormat('0,0.00')}}</el-col>
                </el-row>
              </template>
            </section>
            <v-divider></v-divider>
            <section class="pa-3">
              <h2 class="subtitle mb-0">หมายเหตุ</h2>
            </section>
            <div class="px-3 mb-3">{{order.remark_public}}</div>
            <template v-if="order.payment_type=='creditcard' && payment!=null">
              <v-divider></v-divider>
              <section class="pa-3">
                <h2 class="subtitle mb-3">Credit Card Info</h2>
                <v-layout>
                  <v-flex xs12>
                    <div class="mt-2">
                      <strong class="my-label">ID:</strong>
                      {{payment.id}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Name :</strong>
                      {{payment.card.name}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card No. :</strong>
                      xxxx-xxxx-xxxx-{{payment.card.last_digits}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Brand :</strong>
                      {{payment.card.brand}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Status :</strong>
                      {{payment.status}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Authorized :</strong>
                      {{payment.authorized}}
                    </div>
                  </v-flex>
                </v-layout>
              </section>
            </template>
            <v-divider></v-divider>
            <section class="pa-3" v-if="driver!=null">
              <h2 class="subtitle mb-3">ข้อมูลคนขับ</h2>
              <v-layout
                v-if="driver.detail.status!='ASSIGNING_DRIVER' && driver.detail.status!='CANCELED'"
              >
                <v-flex xs12>
                  <v-layout>
                    <v-flex xs3>
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="driver.driver.photo"
                        :fit="`contain`"
                      ></el-image>
                    </v-flex>
                    <v-flex xs9>
                      <div class="mt-2">
                        <strong class="my-label">เลขที่งาน:</strong>
                        {{order.driver_info_json.orderRef.substring(0, 5)}}-{{order.driver_info_json.orderRef.substring(5, 10)}}
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">สถานะ:</strong>
                        <span
                          class="red white--text py-1 px-3"
                          v-if="driver.detail.status=='CANCELED'"
                        >
                          <i class="far fa-times-circle"></i> ยกเลิกงานแล้ว
                        </span>
                        <span
                          class="green white--text py-1 px-3"
                          v-else-if="driver.detail.status=='COMPLETED'"
                        >
                          <i class="far fa-check-circle"></i> จัดส่งเรียบร้อยแล้ว
                        </span>
                        <span class="blue white--text py-1 px-3" v-else>
                          <i class="fas fa-motorcycle"></i> กำลังดำเนินการ
                        </span>
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">ชื่อคนขับ:</strong>
                        {{driver.driver.name}} | โทร. {{driver.driver.phone}}
                      </div>
                      <!--
                      <div class="mt-2">
                        <strong class="my-label">ราคา:</strong>
                        ฿ {{driver.detail.price.amount}}
                      </div>
                      -->
                      <div class="mt-2">
                        <strong class="my-label">ติดตาม:</strong>
                        <a
                          :href="`https://share.lalamove.com/?TH`+order.driver_info_json.orderRef+`&lang=th_TH`"
                          target="_blank"
                        >https://share.lalamove.com/?TH{{order.driver_info_json.orderRef}}&lang=th_TH</a>
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">Call Center:</strong>ต้องการยกเลิกงานโทร. 02-029-1494
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout v-if="driver.detail.status=='ASSIGNING_DRIVER'">
                <v-flex xs12>
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-3">กำลังหาคนขับ</div>
                </v-flex>
              </v-layout>
              <v-layout v-if="driver.detail.status=='CANCELED'">
                <v-flex xs12>คนขับถูกยกเลิก</v-flex>
              </v-layout>
            </section>
          </el-card>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md4 :class="{'pl-4 mt-0': $vuetify.breakpoint.mdAndUp}">
        <div class="sticky">
          <el-card class="box-card">
            <div style="margin-top: 15px;">
              <el-input placeholder="Please input" v-model="shareUrl">
                <template slot="append">
                  <i class="far fa-copy"></i>
                </template>
              </el-input>
            </div>
            <v-divider class="my-3"></v-divider>
            <h3 class="subtitle pb-1 pt-4">หลักฐานการชำระเงิน</h3>
            <v-layout class="mt-3">
              <v-flex xs12 class="text-xs-center">
                <div
                  v-if="order.payment.payment_image_url!=null"
                  class="pa-3 mb-3"
                  style="background-color:#eee; border-radius:12px;"
                >
                  <h6 class="font-weight-bold">อัพโหลดโดยลูกค้า</h6>
                  <img :src="order.payment.payment_image_url" style="width:100%" />
                </div>
                <div
                  v-if="order.payment.payment_image_url_admin!=null"
                  class="pa-3 mb-3"
                  style="background-color:#eee; border-radius:12px;"
                >
                  <h6 class="font-weight-bold">อัพโหลดโดยแอดมิน</h6>
                  <img :src="order.payment.payment_image_url_admin" style="width:100%" />
                </div>
                <div
                  v-if="order.payment.payment_image_url==null && order.payment.payment_image_url_admin==null"
                  class="my-2 text-xs-center"
                >ยังไม่มีหลักฐานการชำระเงิน</div>
                <template v-if="order.status=='pending' || order.status=='new'">
                  <el-upload
                    class="upload-demo"
                    drag
                    :on-success="handleSuccess"
                    :file-list="file"
                    :action="deliveryApiDomain+`/console/orders/`+order.order_reference+`/upload`"
                    :headers="uploadHeaders"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      ส่งภาพการชำระเงิน
                      <em>กดที่นี่</em>
                    </div>
                    <!--
                    <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
                    -->
                  </el-upload>
                </template>
              </v-flex>
            </v-layout>
            <v-divider class="my-3"></v-divider>
            <section>
              <h3 class="subtitle pb-1 pt-4">ดำเนินการ</h3>
              <v-list>
                <template v-if="order.status=='new'">
                  <v-list-tile @click="onUpdateStatusTo('accepted')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>ยืนยันออเดอร์</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template
                  v-if="order.status=='accepted' || order.status=='processing' || order.status=='cooking'"
                >
                  <template v-if="order.status=='accepted'">
                    <v-list-tile @click="onUpdateStatusTo('processing')">
                      <v-list-tile-action>
                        <v-icon small>fas fa-spinner</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>ส่งออเดอร์ให้หน้าร้าน/ครัว</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                  <template v-if="order.order_type=='delivery'">
                    <v-list-tile @click="onRequestLalamoveOpen">
                      <v-list-tile-action>
                        <v-icon small>fas fa-motorcycle</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>เรียกรถ Lalamove</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile @click="onDriverDialogOpen">
                      <v-list-tile-action>
                        <v-icon small>fas fa-people-carry</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>เลือกพนักงานส่งของ</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                </template>
                <template
                  v-if=" ['processing', 'cooking', 'ready-to-go', 'delivering'].includes(order.status)"
                >
                  <v-list-tile @click="onUpdateStatusTo('completed')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>จัดส่งแล้ว/ออเดอร์เรียบร้อย</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template v-if="order.status=='cancelled' || order.status=='completed'">
                  <v-list-tile @click="onUpdateStatusTo('new')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-retweet</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>กลับสถานะ</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template v-if="order.status!='cancelled' && order.status!='completed'">
                  <v-divider></v-divider>
                  <v-list-tile @click="reScheduleDialog=true">
                    <v-list-tile-action>
                      <v-icon small>far fa-clock</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>เปลี่ยนเวลาจัดส่ง/รับอาหาร</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-if="order.order_type=='delivery' && driver!=null">
                    <v-divider></v-divider>
                    <v-list-tile @click="cancelDriverDialog=true">
                      <v-list-tile-action>
                        <v-icon small>far fa-window-close</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>ยกเลิกรถ Lalamove</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <v-divider></v-divider>
                  <v-list-tile @click="cancelOrderDialog = true">
                    <v-list-tile-action>
                      <v-icon small>far fa-window-close</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>ยกเลิกออเดอร์</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </section>
            <section v-if="order.payment=='creditcard'">
              <h3 class="subtitle pb-1 pt-4">การเงิน</h3>
              <v-list v-if="order.payment=='creditcard'">
                <template v-if="payment.capturable">
                  <v-list-tile @click="onCapturePayment">
                    <v-list-tile-content>
                      <v-list-tile-title>Capture</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template v-if="payment.refundable">
                  <v-list-tile @click="onRefundPayment">
                    <v-list-tile-content>
                      <v-list-tile-title>Setup Refund</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
              </v-list>
            </section>
            <v-divider></v-divider>
            <section>
              <h3 class="subtitle pb-1 pt-4">อื่นๆ</h3>
              <v-list>
                <v-list-tile @click="recieptDialog = true">
                  <v-list-tile-action>
                    <v-icon small>fas fa-receipt</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>ดูใบรายการ</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>

                <v-list-tile @click="print()">
                  <v-list-tile-action>
                    <v-icon small>fas fa-print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>พิมพ์ใบรายการ</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
              </v-list>
            </section>
          </el-card>
        </div>
      </v-flex>
    </v-layout>

    <el-dialog
      title="Reciept"
      v-if="order!=null"
      :visible.sync="recieptDialog"
      width="435px"
      center
    >
      <div id="print-area" style="font-size:0.8rem;">
        <v-layout class="mb-5" row wrap>
          <v-flex xs12>
            <el-row class="mt-2 subtitle">
              <el-col :span="12">
                <strong>หมายเลขออเดอร์ :</strong>
              </el-col>
              <el-col
                :span="12"
                class="text-xs-right"
              >{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>สร้างเมื่อ :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">{{order.created_at}}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ประเภทการสั่งซื้อ :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.order_type=='pickup'">
                  <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                </div>
                <div v-if="order.order_type=='delivery'">
                  <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                </div>
                <div v-if="order.order_type=='commerce'">
                  <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                </div>
                <div v-if="order.order_type=='coupon'">
                  <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>การชำระเงิน :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.payment_type=='transfer'">โอนเงิน</div>
                <div v-if="order.payment_type=='cash'">ชำระเงินสด</div>
                <div v-if="order.payment_type=='creditcard'">บัตรเครดิต</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ช่องทางการขาย :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.order_channel=='liff'">Line Official Account</div>
                <div v-else>{{order.order_channel}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ข้อมูลลูกค้า :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                {{order.user_ref_json.firstname}} {{order.user_ref_json.lastname}}
                -
                <i
                  class="fas fa-mobile-alt"
                ></i>
                {{order.user_ref_json.mobile}}
              </el-col>
            </el-row>
          </v-flex>
        </v-layout>

        <template v-if="order.order_basket.product_list.length>0">
          <el-row
            :gutter="10"
            v-for="(item, index) in order.order_basket.product_list"
            v-bind:key="index"
          >
            <el-col :span="2" class="mb-3">
              <span>{{item.quantity}} x</span>
            </el-col>
            <el-col :span="17" class="mb-3">
              {{item.name}}
              <div v-if="item.modifiers!=null">
                <div
                  class="modifiers"
                  style="padding-left: 20px;"
                  v-for="(subject, index) in item.modifiers"
                  v-bind:key="index"
                >
                  {{subject.title}}
                  <div v-if="!subject.duplicate">
                    <div v-for="(item, j) in subject.items" v-bind:key="j">
                      <li class="choice-item" v-if="item.checked">{{item.name}}</li>
                    </div>
                  </div>
                  <div v-if="subject.duplicate">
                    <li
                      v-for="(item, j) in subject.items"
                      v-bind:key="j"
                    >{{item.name}} {{item.checked}}</li>
                  </div>
                </div>
              </div>
              <div class="mt-0" v-if="item.remark !=null">Remark : {{item.remark }}</div>
            </el-col>
            <el-col
              :span="5"
              class="mb-3 text-xs-right"
            >฿ {{item.regular_price*item.quantity | numFormat('0,0')}}</el-col>
          </el-row>
          <v-divider class="my-2"></v-divider>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าอาหาร</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.food | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">VAT</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.vat | numFormat('0,0.00')}}</el-col>
          </el-row>

          <el-row :gutter="10" class="subtitle" v-if="order.amount.discount<0">
            <el-col :span="12" class="mb-3">ส่วนลด</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.discount | numFormat('0,0.00')}}</el-col>
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-2">รวม</el-col>
            <el-col
              :span="12"
              class="mb-2 text-xs-right"
            >฿ {{parseFloat(order.amount.food)+parseFloat(order.amount.vat) | numFormat('0,0.00')}}</el-col>
          </el-row>

          <v-divider class="my-2"></v-divider>

          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{parseFloat(order.amount.delivery)+parseFloat(order.amount.delivery_tax) | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="subtitle" v-if="order.amount.extra>0">
            <el-col :span="12" class="mb-2">ค่าบริการอื่นๆ</el-col>
            <el-col
              :span="12"
              class="mb-2 text-xs-right"
            >฿ {{order.amount.extra | numFormat('0,0.00')}}</el-col>
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{parseFloat(order.amount.total) | numFormat('0,0.00')}}</el-col>
          </el-row>
        </template>
        <div class="my-0 text-xs-right">
          ***
          <span v-if="order.order_type=='delivery'">จัดส่ง</span>
          <span v-if="order.order_type=='pickup'">รับอาหาร</span>
          {{order.datetime_received | moment("DD/MM/YY HH:mm")}}
        </div>
        <div
          v-if="order.remark_public!=''"
          class="my-0 text-xs-left"
        >*** {{order.remark_public}} ***</div>
        <v-divider></v-divider>
        <!--
        <div v-if="order.payment_type=='cash'" class="my-3 text-xs-center">
          <label>โปรดชำระเงินที่</label>
          <div>019-1-80933-5</div>
          <div>บจก. ฮาลาลไลซ์ | ธนาคารกสิกรไทย</div>
        </div>
        -->
        <div class="my-3 text-xs-center">
          <div>Thank You</div>
        </div>
      </div>
      <v-btn block depressed color="primary" @click="print()">พิมพ์ใบรายการ</v-btn>
    </el-dialog>

    <v-dialog v-model="reScheduleDialog" scrollable max-width="450px">
      <v-card>
        <v-card-title>
          <strong>ต้องการเวลาจัดส่งหรือเวลารับอาหาร?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 180px;">
          <div
            class="text-xs-center ma-3"
          >เวลาเดิม : {{order.datetime_received | moment("DD/MM/YYYY HH:mm")}}</div>
          <div class="text-xs-center ma-3">
            <i class="fas fa-arrow-circle-down"></i>
          </div>
          <div class="text-xs-center ma-3">
            <el-date-picker
              v-model="new_datetime_received"
              type="datetime"
              :format="`dd/MM/yyyy HH:mm`"
              :picker-options="pickerOptions"
              placeholder="เลือกเวลาจัดส่งใหม่"
              default-time="12:00:00"
              :size="`large`"
            ></el-date-picker>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="reScheduleDialog = false">ปิด</v-btn>
          <v-btn color="primary" depressed @click="onReSchedule()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDriverDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการยกเลิกคนขับใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px;"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="cancelDriverDialog = false">ปิด</v-btn>
          <v-btn color="primary" depressed @click="cancelDriver()">ใช่</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelOrderDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>เหตุผลในการยกเลิกออเดอร์</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px;">
          <v-radio-group v-model="cancelReason">
            <v-radio
              class="mt-2"
              color="primary"
              label="ติดต่อร้านค้าไม่ได้"
              value="ติดต่อร้านค้าไม่ได้"
            ></v-radio>
            <v-radio class="mt-2" color="primary" label="ร้านค้าปิดทำการ" value="ร้านค้าปิดทำการ"></v-radio>
            <v-radio class="mt-2" color="primary" label="อาหารหมด" value="อาหารหมด"></v-radio>
            <v-radio class="mt-2" color="primary" label="เรียกคนขับไม่ได้" value="เรียกคนขับไม่ได้"></v-radio>
            <v-radio class="mt-2" color="primary" label="ลูกค้ายกเลิก" value="ลูกค้ายกเลิก"></v-radio>
            <v-radio class="mt-2" color="primary" label="ออเดอร์ทดสอบ" value="ออเดอร์ทดสอบ"></v-radio>
            <v-radio class="mt-2" color="primary" label="อื่นๆ" value="อื่นๆ"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="cancelOrderDialog = false">ปิด</v-btn>
          <v-btn color="primary" flat @click="onUpdateStatusTo('cancelled')">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- v-if="order.driver_info_json!=null" -->
    <lalamove-dialog
      :deliveryData="deliveryData"
      :order="order"
      :showDialog="lalamoveDialog"
      @save="onSaveLalamove"
      @close="onRequestLalamoveClose"
    ></lalamove-dialog>

    <driver-dialog
      :order="order"
      :showDialog="driverDialog"
      @save="onSaveDriver"
      @close="onDriverDialogClose"
    ></driver-dialog>
  </v-container>
</template>
<script>
import { deliveryApiDomain, harisChannelKey } from "../../utils/Constants";

import Service from "../../services";

import LalamoveDialog from "../../components/LalamoveDialog";
import DriverDialog from "../../components/DriverDialog";

import moment from "moment";

export default {
  components: {
    LalamoveDialog,
    DriverDialog,
  },
  props: ["order_ref"],
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      loading: null,
      order: null,
      payment: null,
      driver: null,
      shareUrl: "",
      recipient: { name: "", mobile: "" },
      cancelReason: null,
      lalamoveDialog: false,
      driverDialog: false,
      deliveryData: null,
      recieptDialog: false,
      reScheduleDialog: false,
      cancelOrderDialog: false,
      cancelDriverDialog: false,
      file: [],
      uploadHeaders: {
        Authorization: "",
      },
      steps: [1, 0, 0, 0, 0, 0],
      gg_url: "",
      driverInterval: null,
      new_datetime_received: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().setDate(new Date().getDate() - 1);
        },
      },
    };
  },
  computed: {},
  created() {
    let vuex = JSON.parse(localStorage.getItem("halalize"));
    let accessToken = vuex.Auth.accessToken;
    this.uploadHeaders.Authorization = "Bearer " + accessToken;
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      this.showLoading();
      Promise.all([
        this.$store
          .dispatch("Order/getOrderByRef", this.order_ref)
          .then((res) => {
            if (res.status == "ok") {
              this.order = res.data;
              this.new_datetime_received = this.order.datetime_received;

              if (this.order.status == "new") {
                this.steps[1] = 1;
              }
              if (this.order.status == "acccepted") {
                this.steps[1] = 1;
                this.steps[2] = 1;
              }
              if (this.order.status == "processing") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
              }
              if (
                this.order.status == "cooking" ||
                this.order.status == "ready-to-go" ||
                this.order.status == "delivering"
              ) {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
                this.steps[4] = 1;
              }
              if (this.order.status == "completed") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
                this.steps[4] = 1;
                this.steps[5] = 1;
              }

              this.shareUrl =
                "https://get.hlzd.link/o/" +
                this.order.order_reference.toLowerCase();
              this.checkRecipient();
            }

            if (this.order.order_type == "delivery") {
              console.log(this.order.delivery_info_json);
              let origin =
                this.order.delivery_info_json.whereFrom.latitude +
                "," +
                this.order.delivery_info_json.whereFrom.longitude;
              let destination =
                this.order.delivery_info_json.whereTo.lat +
                "," +
                this.order.delivery_info_json.whereTo.lng;

              this.gg_url =
                "https://www.google.com/maps/dir/?api=1&origin=" +
                origin +
                "&destination=" +
                destination;
            }
          }),

        this.$store
          .dispatch("Order/getOrderPayment", this.order_ref)
          .then((res) => {
            this.payment = res.data;
          }),
      ]).then(() => {
        this.hideLoading();
        this.$store
          .dispatch("Order/getOrderDriver", this.order.order_id)
          .then((res) => {
            this.driver = res.data;
          });
      });
    },
    checkRecipient() {
      if (this.order.user_recipient == null) {
        this.recipient.name = this.order.user_ref_json.firstname;
        this.recipient.mobile = this.order.user_ref_json.mobile;
      } else {
        this.recipient.name = this.order.user_recipient.recipient_name;
        this.recipient.mobile = this.order.user_recipient.recipient_mobile;
      }
    },
    onReSchedule() {
      let new_dt = moment(this.new_datetime_received);
      let old_dt = moment();

      if (new_dt.diff(old_dt) <= 0) {
        alert("วันเวลาจัดส่งใหม่ผ่านมาแล้ว");
        return;
      }

      Service.Order.updateDatetime(this.order.order_reference, {
        datetime_received: moment(this.new_datetime_received).format(
          "YYYY-MM-DD HH:mm"
        ),
      }).then((res) => {
        if (res.success) {
          this.order.datetime_received = res.data.datetime_received;
          this.reScheduleDialog = false;

          this.$notify({
            title: "สำเร็จ",
            message: "แก้ไขเวลาจัดส่งเรียบร้อยแล้ว",
            type: "success",
          });
        }
      });
    },
    onRequestLalamoveOpen() {
      this.deliveryData = {
        orderId: this.order.order_id,
        datetimeReceived: this.order.datetime_received,
        deliveryInfo: this.order.delivery_info_json,
        recipientInfo: this.order.user_ref_json,
      };
      this.lalamoveDialog = true;
    },
    onRequestLalamoveClose() {
      this.delivery_info = null;
      this.lalamoveDialog = false;
    },
    onSaveLalamove() {
      this.delivery_info = null;
      this.lalamoveDialog = false;

      this.$notify({
        title: "แจ้งเตือน",
        message: "กำลังหาคนขับ...กรุณารอซักครู่",
      });

      this.$store
        .dispatch("Order/getOrderDriver", this.order.order_id)
        .then((res) => {
          this.driver = res.data;
        });

      this.driverInterval = setInterval(() => {
        this.$store
          .dispatch("Order/getOrderDriver", this.order.order_id)
          .then((res) => {
            this.driver = res.data;
            if (this.driver.detail.status != "ASSIGNING_DRIVER") {
              clearInterval(this.driverInterval);
              this.loadOrder();

              this.$notify({
                title: "สำเร็จ",
                message: "คนขับรับงานของคุณแล้ว",
                type: "success",
              });
            }
          });
      }, 10000);
    },
    onDriverDialogOpen() {
      this.driverDialog = true;
    },
    onDriverDialogClose() {
      this.driverDialog = false;
    },
    onSaveDriver() {},
    onUpdateStatusTo(status) {
      this.showLoading();
      let data = {
        status: status,
        remark_internal: "",
      };

      if (status == "cancelled") {
        data.remark_internal = this.cancelReason;
      }

      Service.Order.updateStatus(this.order.order_id, data).then((res) => {
        if (res.success) {
          this.cancelOrderDialog = false;
          this.loadOrder();

          this.$notify({
            title: "สำเร็จ",
            message: "อัพเดทสถานะเรียบร้อยแล้ว",
            type: "success",
          });
        }
      });
    },
    onCapturePayment() {
      Service.Order.capturePayment(this.order.order_id).then((res) => {
        if (res.success) {
          this.$store
            .dispatch("Order/getOrderPayment", this.order_id)
            .then((res) => {
              this.payment = res.data;
            });
        }
      });
    },
    onRefundPayment() {},
    cancelDriver() {
      Service.Order.cancelDriver(this.order.order_id).then((res) => {
        if (res.success) {
          if (res.data.done) {
            this.cancelDriverDialog = false;
            this.$store
              .dispatch("Order/getOrderDriver", this.order.order_id)
              .then((res) => {
                this.driver = res.data;

                this.$notify({
                  title: "สำเร็จ",
                  message: "ยกเลิกคนขับเรียบร้อยแล้ว",
                  type: "success",
                });
              });
          } else {
            this.$notify({
              title: "Oops!",
              message: "ไม่สามารถยกเลิกคนขับได้",
              type: "warning",
            });
          }
        }
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    print() {
      if (!this.recieptDialog) {
        this.recieptDialog = true;
      }
      setTimeout(() => {
        this.$htmlToPaper("print-area", null, () => {
          this.recieptDialog = false;
        });
      }, 800);
      return;
    },
    hideLoading() {
      this.loading.close();
    },
    handleSuccess() {},
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.driverInterval);
    next();
  },
};
</script>
<style lang="scss">
.promotion {
  font-weight: bold;
  border-radius: 8px;
}

.el-upload-dragger {
  width: 200px !important;
}
</style>
